var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1253fa",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 .25C5.51.25.25 5.51.25 12S5.51 23.75 12 23.75 23.75 18.49 23.75 12 18.49.25 12 .25zm0 1.5c5.66 0 10.25 4.59 10.25 10.25S17.66 22.25 12 22.25 1.75 17.66 1.75 12 6.34 1.75 12 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.819 3.873a.75.75 0 01.976-.073l.084.073L20.166 19.16a.75.75 0 01-.976 1.133l-.084-.072L3.819 4.933a.75.75 0 010-1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.106 3.873a.75.75 0 011.133.976l-.073.084-7.568 7.57a.75.75 0 01-1.134-.977l.073-.084 7.569-7.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.042 11.297l10.759.004a.75.75 0 01.101 1.494l-.102.006-10.758-.004a.75.75 0 01-.102-1.493l.102-.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 .25a.75.75 0 01.743.649L12.75 1l-.008 11a.75.75 0 01-1.493.1l-.007-.1.008-11A.75.75 0 0112 .25z"
  }))));
}
export default SvgDashboard;